<template>
  <div class="q_pad_lr15px q_mar_t15px">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_excha q_bor_bottom q_pad_tb15px" v-for="item in list" :key="item.id" @click="goToExchangedea(item.id)">
          <div class="q_mar_b10px">
            <span class="q_text_s q_color_gray">{{ item.createTime }}</span>
            <van-button color="#f2f3f7" size="mini" class="q_flo_right q_color_default" v-if="item.cdType === '0'">待领取
            </van-button>
            <van-button color="#f2f3f7" size="mini" class="q_flo_right q_color_black" v-if="item.cdType === '1'">已领取
            </van-button>
          </div>
          <div class="q_vertical_left">
            <van-image fit="cover" :src="convertImg(item.goodsPic)"/>
            <div class="q_inlineblock q_mar_l10px q_excha_cen">
              <p class="q_mar_b10px q_text_m q_moit2 q_bold">{{ item.goodsName }}</p>
              <p class="q_mar_t10px q_text_s q_color_gray">{{ item.score }}积分</p>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
  </div>
</template>

<script>
import {listIntegral} from "@/api/integral";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Myexchange',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 10,
        type: '1'
      }
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 5,
        type: '1'
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询我的兑换信息列表
      listIntegral(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToExchangedea(id) {
      this.$router.push({
        path: '/mine/Exchangedea', query: {id: id}
      });
    },
  }
}
</script>
<style scoped="scoped">
.q_excha .van-image {
  width: 70px;
  height: 70px;
}

.q_excha >>> .van-image__img {
  border-radius: 5px;
}

.q_excha_cen .q_moit2 {
  width: 270px;
}
</style>
